import React from 'react'

import { useRecoilValue } from 'recoil'
import { pageState } from 'Pages/EmailSendingWizard/recoil/state/page'
import {
  RECIPIENTS_ALL,
  RECIPIENTS_GROUP_FILTER,
  RECIPIENTS_TEST_GROUP
} from 'Pages/EmailSendingWizard/const'
import StyledIconFilterGroup from './IconFilterGroup'
import StyledIconTestGroup from './IconTestGroup'
import StyledIconAll from './IconAll'


const BoxResultIcon = () => {
  const { recipients } = useRecoilValue(pageState)

  const getIcon = () => {
    if (recipients === RECIPIENTS_GROUP_FILTER) {
      return <StyledIconFilterGroup />
    } else if (recipients === RECIPIENTS_TEST_GROUP) {
      return <StyledIconTestGroup />
    } else if (recipients === RECIPIENTS_ALL) {
      return <StyledIconAll />
    }
  }

  return <>{getIcon()}</>
}

export default BoxResultIcon
